import React, { useEffect, useState, useRef } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import { Box, Tabs } from '@mui/material';
import styled from 'styled-components';
import { Tab } from '@mui/material';
import { useStoreWrapper } from 'stores/StoreHelper';
import RichEditor from 'components/editor/RichEditor';
import Button from 'components/input/Button';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminSystemLocaleDto, AdminTermRequestDto, TermDto } from 'services/data-contracts';
import { toast } from 'react-toastify';
import { useLocale } from 'providers/LocalProvider';

const TermsContainer = ({
  type,
  title,
}: {
  type: NonNullable<TermDto['category']>;
  title: { [key: string]: string };
}) => {
  const { languageStore } = useStoreWrapper();
  const { activeLocale } = useLocale();

  const [value, setValue] = React.useState(0);
  // const [languages, setLanguages] = useState<AdminSystemLocaleDto[]>([]);
  const [editorContents, setEditorContents] = useState<{ [key: string]: string }>({});

  const editorTitleRef = useRef<{ [key: string]: string }>({});
  const editorContentRef = useRef<{ [key: string]: string }>({});

  // const getLanguage = async () => {
  //   const r = ServiceHelper.adminLocaleService?.getLocales1().then((res) => {
  //     const activeLocales = res.data?.filter((locale) => locale.isActive);
  //     setLanguages(activeLocales);
  //   });
  //   // const response = (await languageStore.getLanguage()) as any as {
  //   //   code: string;
  //   //   title: string;
  //   // }[];
  // };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleEditorChange = (
    content: string | undefined,
    language: string,
    type: 'title' | 'content',
  ) => {
    if (content === undefined) return;

    if (type === 'title') {
      editorTitleRef.current = {
        ...editorTitleRef.current,
        [language]: content,
      };
    } else {
      editorContentRef.current = {
        ...editorContentRef.current,
        [language]: content,
      };
    }
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleSave = () => {
    if (!type) return;

    const contents: AdminTermRequestDto = {
      localizedTitle: editorTitleRef.current,
      localizedContent: editorContentRef.current,
    };

    ServiceHelper?.adminTermsService?.saveTerm(type, contents).then((res) => {
      if (res?.status === 200) {
        toast.success(title[activeLocale?.[0]?.locale!] + '이 변경되었습니다.');
      }
    });
  };

  useEffect(() => {
    // 각 언어별 제목 번역

    const initialContents: { [key: string]: string } = {};

    activeLocale?.forEach((code) => {
      // 지원하지 않는 언어코드가 있을 경우 영어로 기본 설정
      if (!title[code?.locale!]) {
        title[code?.locale!] = title['en'];
      }
      initialContents[code?.locale!] = '';
    });

    editorTitleRef.current = title;
    editorContentRef.current = initialContents;
  }, [activeLocale]);

  useEffect(() => {
    if (!type) return;

    ServiceHelper?.adminTermsService?.getTermByCategory1(type).then((res) => {
      if (res?.data?.localizedTitle && res?.data?.localizedContent) {
        editorTitleRef.current = res.data.localizedTitle;
        setEditorContents(res.data.localizedContent);
        editorContentRef.current = res.data.localizedContent;
      }
    });
  }, []);

  return (
    <PageLayout>
      {/* 약관 설정 관련 컨텐츠 */}
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
        {activeLocale?.map((language, index) => (
          <Tab label={language.name} {...a11yProps(index)} />
        ))}
      </Tabs>
      {activeLocale?.map((language, index) => (
        <LocalTabPanel key={language.locale} show={value === index}>
          <div style={{ marginBottom: '20px' }}></div>
          <RichEditor
            onEditorChange={(content) => handleEditorChange(content, language.locale!, 'content')}
            defaultValue={editorContents[language.locale!]}
          />
        </LocalTabPanel>
      ))}
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
        <Button
          style={{ width: 200 }}
          onClick={() => {
            handleSave();
          }}
        >
          저장
        </Button>
      </div>
    </PageLayout>
  );
};

const LocalTabPanel = styled.div<{ show: boolean }>`
  padding: 30px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export default TermsContainer;
